<template>
  <div class="gateway-login">
    <div class="gateway-login__stage">
      <aside class="gateway-login__brand" aria-label="Brand">
        <div class="gateway-login__atmosphere" aria-hidden="true">
          <div class="gateway-login__orb gateway-login__orb--a"></div>
          <div class="gateway-login__orb gateway-login__orb--b"></div>
          <div class="gateway-login__grid"></div>
          <svg
            class="gateway-login__signal"
            viewBox="0 0 420 320"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="gateway-login__path"
              d="M40 220 C110 120, 180 280, 250 160 S380 80, 400 140"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-dasharray="6 8"
            />
            <circle class="gateway-login__node" cx="40" cy="220" r="6" />
            <circle class="gateway-login__node gateway-login__node--delay" cx="250" cy="160" r="6" />
            <circle class="gateway-login__node gateway-login__node--delay-2" cx="400" cy="140" r="6" />
            <rect
              x="286"
              y="48"
              width="108"
              height="52"
              rx="14"
              class="gateway-login__bubble"
            />
            <rect
              x="48"
              y="248"
              width="132"
              height="44"
              rx="14"
              class="gateway-login__bubble gateway-login__bubble--soft"
            />
          </svg>
        </div>

        <router-link to="/home" class="gateway-login__home">
          ← Beranda
        </router-link>

        <div class="gateway-login__brand-copy">
          <p class="gateway-login__eyebrow">WhatsApp Gateway Service</p>
          <h1 class="gateway-login__name">
            {{ info.app_name || "SenderWA" }}
          </h1>
          <p class="gateway-login__tagline">
            {{
              info.app_desc ||
              "Kirim, antre, dan pantau pesan WhatsApp bisnis dari satu panel yang andal."
            }}
          </p>
        </div>

        <p class="gateway-login__footnote">
          © {{ year }} {{ info.app_company || "SenderWA" }}
        </p>
      </aside>

      <section class="gateway-login__panel">
        <div class="gateway-login__form-wrap">
          <header class="gateway-login__form-head">
            <h2 class="gateway-login__form-title">Masuk ke akun</h2>
            <p class="gateway-login__form-desc">
              Gunakan kredensial gateway Anda untuk mengelola sesi, kontak, dan
              pengiriman pesan.
            </p>
          </header>

          <form class="gateway-login__form" @submit.prevent="postAuthent">
            <div class="gateway-login__field">
              <label class="gateway-login__label" for="gateway-email">Email</label>
              <input
                id="gateway-email"
                v-model="uname"
                class="gateway-login__input"
                type="email"
                name="email"
                autocomplete="username"
                placeholder="nama@perusahaan.com"
                :disabled="submitting"
              />
            </div>

            <div class="gateway-login__field">
              <label class="gateway-login__label" for="gateway-password">Kata sandi</label>
              <div class="gateway-login__password">
                <input
                  id="gateway-password"
                  v-model="upass"
                  class="gateway-login__input"
                  :type="showPassword ? 'text' : 'password'"
                  name="password"
                  autocomplete="current-password"
                  placeholder="Masukkan kata sandi"
                  :disabled="submitting"
                />
                <button
                  type="button"
                  class="gateway-login__toggle"
                  :aria-label="showPassword ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'"
                  @click="showPassword = !showPassword"
                >
                  {{ showPassword ? "Sembunyi" : "Lihat" }}
                </button>
              </div>
            </div>

            <button
              type="submit"
              class="gateway-login__submit"
              :disabled="submitting"
            >
              <span v-if="!submitting">Masuk</span>
              <span v-else>Memverifikasi…</span>
            </button>
          </form>

          <p class="gateway-login__secure">
            Belum punya akun?
            <router-link to="/registrasi-user">Daftar sekarang</router-link>
          </p>
          <p class="gateway-login__home-mobile">
            <router-link to="/home">← Kembali ke beranda</router-link>
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "LoginComponent",
  data: () => ({
    uname: "",
    upass: "",
    showPassword: false,
    submitting: false,
    year: new Date().getFullYear(),
  }),
  mounted() {
    this.setPage({
      crud: false,
    });
  },
  computed: {
    ...mapState(["device", "theme", "info", "http", "snackbar", "auth"]),
  },
  methods: {
    ...mapActions(["setPage", "signIn"]),
    postAuthent() {
      if (this.submitting) return;
      this.submitting = true;
      this.signIn({
        username: this.uname.replace(/ /g, ""),
        userpass: this.upass,
      })
        .then((pass) => {
          if (!pass) return;
          try {
            const role = this.auth.user.user.authent;
            if (
              role === "superadmin" ||
              role === "administrator" ||
              role === "customer"
            ) {
              this.$router.push({ name: "dashboard" });
            }
          } catch (error) {
            this.snackbar.color = "red";
            this.snackbar.text = error;
            this.snackbar.state = true;
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@500;600;700&family=Source+Sans+3:wght@400;500;600&display=swap");

.gateway-login {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-paper: #f8fbf9;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
  --gw-danger: #b42318;

  min-height: 100vh;
  font-family: "Source Sans 3", "Montserrat", sans-serif;
  color: var(--gw-ink);
  background: var(--gw-paper);
}

.gateway-login__stage {
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(320px, 0.85fr);
  min-height: 100vh;
}

.gateway-login__brand {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: clamp(2rem, 5vw, 3.5rem);
  color: #f4fbf7;
  background:
    radial-gradient(120% 90% at 0% 0%, #1a6b4d 0%, transparent 55%),
    radial-gradient(90% 70% at 100% 100%, #0a2f24 0%, transparent 50%),
    linear-gradient(155deg, #0b3d2e 0%, #0f5c45 48%, #0a3327 100%);
}

.gateway-login__atmosphere {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.gateway-login__orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(2px);
  opacity: 0.35;
  animation: gateway-float 10s ease-in-out infinite;
}

.gateway-login__orb--a {
  width: 280px;
  height: 280px;
  top: -60px;
  right: -40px;
  background: radial-gradient(circle, var(--gw-mint) 0%, transparent 70%);
}

.gateway-login__orb--b {
  width: 220px;
  height: 220px;
  bottom: 8%;
  left: -50px;
  background: radial-gradient(circle, #2aad7a 0%, transparent 70%);
  animation-delay: -3s;
}

.gateway-login__grid {
  position: absolute;
  inset: 0;
  opacity: 0.12;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.35) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.35) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(ellipse at 40% 40%, #000 30%, transparent 75%);
}

.gateway-login__signal {
  position: absolute;
  right: 4%;
  bottom: 18%;
  width: min(420px, 70%);
  color: rgba(255, 255, 255, 0.55);
}

.gateway-login__path {
  animation: gateway-dash 18s linear infinite;
}

.gateway-login__node {
  fill: var(--gw-mint);
  animation: gateway-pulse 2.8s ease-in-out infinite;
}

.gateway-login__node--delay {
  animation-delay: 0.6s;
}

.gateway-login__node--delay-2 {
  animation-delay: 1.2s;
}

.gateway-login__bubble {
  fill: rgba(255, 255, 255, 0.14);
  stroke: rgba(255, 255, 255, 0.28);
  animation: gateway-rise 5.5s ease-in-out infinite;
}

.gateway-login__bubble--soft {
  animation-delay: -2s;
}

.gateway-login__home {
  position: relative;
  z-index: 1;
  align-self: flex-start;
  text-decoration: none;
  color: rgba(244, 251, 247, 0.8);
  font-size: 0.88rem;
  font-weight: 600;
}

.gateway-login__home:hover {
  color: #fff;
}

.gateway-login__brand-copy {
  position: relative;
  z-index: 1;
  max-width: 34rem;
  margin-top: auto;
  margin-bottom: auto;
  animation: gateway-fade-up 0.7s ease-out both;
}

.gateway-login__eyebrow {
  margin: 0 0 0.85rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--gw-mint);
}

.gateway-login__name {
  margin: 0;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: clamp(2.6rem, 5.5vw, 4.4rem);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
}

.gateway-login__tagline {
  margin: 1.15rem 0 0;
  max-width: 28rem;
  font-size: 1.05rem;
  line-height: 1.55;
  color: rgba(244, 251, 247, 0.82);
}

.gateway-login__footnote {
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: 0.85rem;
  color: rgba(244, 251, 247, 0.55);
}

.gateway-login__panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(1.5rem, 4vw, 3rem);
  background:
    linear-gradient(180deg, rgba(143, 214, 181, 0.12), transparent 28%),
    var(--gw-paper);
  animation: gateway-fade-in 0.55s ease-out 0.12s both;
}

.gateway-login__form-wrap {
  width: 100%;
  max-width: 380px;
}

.gateway-login__form-head {
  margin-bottom: 1.75rem;
}

.gateway-login__form-title {
  margin: 0;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: 1.65rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--gw-ink);
}

.gateway-login__form-desc {
  margin: 0.55rem 0 0;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--gw-muted);
}

.gateway-login__form {
  display: grid;
  gap: 1.05rem;
}

.gateway-login__field {
  display: grid;
  gap: 0.4rem;
}

.gateway-login__label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--gw-forest);
}

.gateway-login__input {
  width: 100%;
  height: 48px;
  padding: 0 0.95rem;
  border: 1px solid var(--gw-line);
  border-radius: 10px;
  background: #fff;
  color: var(--gw-ink);
  font: inherit;
  font-size: 0.98rem;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.gateway-login__input::placeholder {
  color: #91a59b;
}

.gateway-login__input:focus {
  border-color: var(--gw-leaf);
  box-shadow: 0 0 0 3px rgba(31, 122, 87, 0.15);
}

.gateway-login__input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.gateway-login__password {
  position: relative;
}

.gateway-login__password .gateway-login__input {
  padding-right: 4.5rem;
}

.gateway-login__toggle {
  position: absolute;
  top: 50%;
  right: 0.55rem;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: var(--gw-leaf);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.35rem 0.45rem;
}

.gateway-login__toggle:hover {
  color: var(--gw-forest);
}

.gateway-login__submit {
  margin-top: 0.35rem;
  height: 50px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--gw-leaf) 0%, var(--gw-forest) 100%);
  color: #fff;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: transform 0.15s ease, filter 0.15s ease, opacity 0.15s ease;
}

.gateway-login__submit:hover:not(:disabled) {
  filter: brightness(1.05);
  transform: translateY(-1px);
}

.gateway-login__submit:active:not(:disabled) {
  transform: translateY(0);
}

.gateway-login__submit:disabled {
  opacity: 0.72;
  cursor: wait;
}

.gateway-login__secure {
  margin: 1.35rem 0 0;
  font-size: 0.9rem;
  color: var(--gw-muted);
  text-align: center;
}

.gateway-login__secure a {
  color: var(--gw-leaf);
  font-weight: 700;
  text-decoration: none;
}

.gateway-login__secure a:hover {
  color: var(--gw-forest);
  text-decoration: underline;
}

.gateway-login__home-mobile {
  display: none;
  margin: 0.85rem 0 0;
  text-align: center;
  font-size: 0.88rem;
}

.gateway-login__home-mobile a {
  color: var(--gw-leaf);
  font-weight: 700;
  text-decoration: none;
}

@keyframes gateway-fade-up {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes gateway-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes gateway-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(18px);
  }
}

@keyframes gateway-dash {
  to {
    stroke-dashoffset: -280;
  }
}

@keyframes gateway-pulse {
  0%,
  100% {
    opacity: 0.45;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.25);
  }
}

@keyframes gateway-rise {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.85;
  }
  50% {
    transform: translateY(-8px);
    opacity: 1;
  }
}

@media (max-width: 960px) {
  .gateway-login__stage {
    grid-template-columns: 1fr;
  }

  .gateway-login__brand {
    min-height: 42vh;
    padding-bottom: 2rem;
  }

  .gateway-login__signal {
    width: min(280px, 58%);
    bottom: 8%;
    opacity: 0.7;
  }

  .gateway-login__name {
    font-size: clamp(2.2rem, 10vw, 3rem);
  }

  .gateway-login__panel {
    align-items: flex-start;
    padding-top: 2rem;
    padding-bottom: 3rem;
  }

  .gateway-login__home-mobile {
    display: block;
  }
}

@media (max-width: 480px) {
  .gateway-login__brand {
    min-height: auto;
  }

  .gateway-login__signal {
    display: none;
  }

  .gateway-login__footnote {
    margin-top: 1.5rem;
  }
}
</style>
